import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./customStyle.css"


const Carousel = ({ images, customSettings, customStyle = '', customImgStyle = '', shuffleBy = 1 }) => {

    var settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        ...customSettings
    };

    function shuffle(array, cNumber = 1) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + cNumber));
            const temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }

        return array
    }


    return (
        <>

            <div className={`carousel w-[80vw] mx-auto  p-5  ${customStyle}`}>

                <Slider {...settings}>
                    {
                        shuffle(images, shuffleBy).map((img, index) => (

                            <div key={img + index}>
                                <img src={img} className={`w-[240px] mx-auto ${customImgStyle}`} alt="" />
                            </div>
                        ))
                    }

                </Slider>
            </div>


        </>
    )
}

export default Carousel